import React from 'react'

import PodcastsIcon from '@mui/icons-material/Podcasts'

import { PodcastCardStyle } from '../styles'
import PodcastModal from '../modals/PodcastModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const PodcastsCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={PodcastsIcon}
            cardStyle={PodcastCardStyle}
            modal={<PodcastModal {...props} />}
            title={props.title}
            description={props.description}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default PodcastsCard
